import React from "react";

export default function Salve() {
  return (
    <>
      <p>
        Dios te salve, Reina y Madre de misericordia, <br /> vida, dulzura y
        esperanza nuestra. Dios te salve. <br /> A Tí clamamos los desterrados
        hijos de Eva, <br /> a Tí suspiramos, gimiendo y llorando en este valle
        de lágrimas. <br /> Ea, pues, Señora Abogada Nuestra, <br /> vuelve a
        nosotros tus ojos misericordiosos, <br /> y después de este destierro,
        muéstranos a Jesús, <br /> fruto bendito de tu vientre. <br /> Oh,
        clemente, oh piadosa, oh dulce Virgen María. <br /> Ruega por nosotros,
        Santa Madre de Dios, <br /> para que seamos dignos de alcanzar las
        promesas de Nuestro Señor Jesucristo. <br /> <br /> Amén.
      </p>
    </>
  );
}
